/**
 * Order/order products statuses
 *
 * @type {object}
 */
export const allStatusesTypes = {
  canceled: 'canceled',
  deleted: 'deleted',
  delivered: 'delivered',
  forStorage: 'forStorage',
  inStorage: 'inStorage',
  new: 'new',
  notDelivered: 'notDelivered',
  notFinished: 'notFinished',
  onPickupPoint: 'onPickupPoint',
  processed: 'processed',
  repay: 'repay',
  unknown: 'unknown'
};
export const allStatuses = {
  [allStatusesTypes.canceled]: 'Отменен',
  [allStatusesTypes.deleted]: 'Удалён',
  [allStatusesTypes.delivered]: 'Доставлен',
  [allStatusesTypes.forStorage]: 'На склад',
  [allStatusesTypes.inStorage]: 'Доставлен на склад',
  [allStatusesTypes.new]: 'Ожидает подтверждения',
  [allStatusesTypes.notDelivered]: 'Не доставлен',
  [allStatusesTypes.notFinished]: 'Не оплачен',
  [allStatusesTypes.onPickupPoint]: 'Доставлен в ПВЗ',
  [allStatusesTypes.processed]: 'Принят',
  [allStatusesTypes.repay]: 'Не оплачен',
  [allStatusesTypes.unknown]: 'Статус отсутствует'
};
/**
 * Order payment statuses
 *
 * @type {object}
 */

export const paymentStatusesTypes = {
  canceled: 'canceled',
  new: 'new',
  no_money: 'no_money',
  paid: 'paid',
  unknown: 'unknown',
  defected: 'defected',
  transferred: 'transfered'
};
export const paymentStatuses = {
  [paymentStatusesTypes.canceled]: 'Отменен',
  [paymentStatusesTypes.new]: 'Новый',
  [paymentStatusesTypes.no_money]: 'Недостаточно средств',
  [paymentStatusesTypes.paid]: 'Оплачен',
  [paymentStatusesTypes.unknown]: 'Статус отсутствует',
  [paymentStatusesTypes.defected]: 'В браке',
  [paymentStatusesTypes.transferred]: 'Передан'
};
/**
 * Order payment methods
 *
 * @type {{}}
 */

export const paymentMethodsTypes = {
  online: 'online',
  delivery: 'delivery',
  mixed: 'mixed',
  cash: 'cash',
  cashDesc: 'cashDesc',
  credit: 'credit'
};
export const paymentMethods = {
  [paymentMethodsTypes.online]: 'Онлайн',
  [paymentMethodsTypes.delivery]: 'При получении',
  [paymentMethodsTypes.mixed]: 'Онлайн и при получении',
  [paymentMethodsTypes.cash]: 'Наличные',
  [paymentMethodsTypes.cashDesc]: 'На терминале',
  [paymentMethodsTypes.credit]: 'В кредит'
};
/**
 * Product payment methods
 *
 * @type {{delivery: string, online: string}}
 */

export const productPaymentMethodsTypes = {
  online: 'online',
  delivery: 'delivery'
};
export const productPaymentMethods = {
  [productPaymentMethodsTypes.online]: 'Онлайн',
  [productPaymentMethodsTypes.delivery]: 'При получении'
};
/**
 * Order point methods
 *
 * @type {object}
 */

export const pointMethodsTypes = {
  earn: 'earn',
  spend: 'spend'
};
export const pointMethods = {
  [pointMethodsTypes.earn]: 'Заработать',
  [pointMethodsTypes.spend]: 'Потратить'
};
/**
 * Order delivery regions
 *
 * @type {object}
 */

export const deliveryRegionsTypes = {
  city: 'city',
  region: 'region',
  country: 'country',
  pickup: 'pickup'
};
export const deliveryRegions = {
  [deliveryRegionsTypes.city]: 'По городу',
  [deliveryRegionsTypes.region]: 'По окрестностям',
  [deliveryRegionsTypes.country]: 'По стране',
  [deliveryRegionsTypes.pickup]: 'Самовывоз'
};
/**
 * Order delivery methods
 *
 * @type {object}
 */

export const deliveryMethodsTypes = {
  courier: 'courier',
  pickup: 'pickup'
};
export const deliveryMethods = {
  [deliveryMethodsTypes.courier]: 'Курьером',
  [deliveryMethodsTypes.pickup]: 'Самовывоз'
};
/**
 * Order source
 *
 * @type {object}
 */

export const sourcesTypes = {
  android: 'android',
  counter: 'counter',
  ios: 'ios',
  seller: 'seller',
  web: 'web'
};
export const sources = {
  [sourcesTypes.android]: 'Android',
  [sourcesTypes.counter]: 'Магазин',
  [sourcesTypes.ios]: 'IOS',
  [sourcesTypes.seller]: 'Продавец',
  [sourcesTypes.web]: 'Web'
};
/**
 * Order delivery
 *
 * @type {object}
 */

export const orderDeliveryTypes = {
  byAgreement: 'byAgreement',
  free: 'free',
  payment: 'payment',
  pickup: 'pickup'
};
export const orderDelivery = {
  [orderDeliveryTypes.byAgreement]: 'По согласованию',
  [orderDeliveryTypes.free]: 'Бесплатная',
  [orderDeliveryTypes.payment]: 'Платная',
  [orderDeliveryTypes.pickup]: 'Самовывоз'
};
/**
 * Order cancel reason
 *
 * @type {object}
 */

export const cancelReasonsTypes = {
  user_cancel: 'user_cancel',
  user_partial_cancel: 'user_partial_cancel',
  user_partial_timeout: 'user_partial_timeout',
  supplier_cancel: 'supplier_cancel',
  supplier_timeout: 'supplier_timeout',
  company_cancel: 'company_cancel'
};
export const cancelReasons = {
  [cancelReasonsTypes.user_cancel]: 'Отменен пользователем из ЛК или письма',
  [cancelReasonsTypes.user_partial_cancel]: 'Частичный заказ отклонен пользователем',
  [cancelReasonsTypes.user_partial_timeout]: 'Частичный заказ просрочен пользователем',
  [cancelReasonsTypes.supplier_cancel]: 'Товары отклонены поставщиком',
  [cancelReasonsTypes.supplier_timeout]: 'Подтверждение товаров просрочено',
  [cancelReasonsTypes.company_cancel]: 'Отмена компанией'
};
/**
 * Order actions
 *
 * @type {object}
 */

export const orderActionsTypes = {
  commit: 'commit',
  cancel: 'cancel',
  timeout: 'timeout'
};
export const orderActions = {
  [orderActionsTypes.commit]: 'Принят',
  [orderActionsTypes.cancel]: 'Отменен',
  [orderActionsTypes.timeout]: 'Таймаут'
};
/**
 * Order discounts
 *
 * @type {object}
 */

export const orderDiscountsTypes = {
  points: 'points',
  promocode: 'promocode'
};
export const orderDiscounts = {
  [orderDiscountsTypes.points]: 'Скидка за баллы',
  [orderDiscountsTypes.promocode]: 'Скидка за промокод'
};
/**
 * Order hold states
 *
 * @type {object}
 */

export const holdStatesTypes = {
  committed: 'committed',
  holding: 'holding',
  released: 'holdingholding',
  weight_committed: 'weight_committed',
  weight_holding: 'weight_holding'
};
export const holdStates = {
  [holdStatesTypes.committed]: 'Принят',
  [holdStatesTypes.holding]: 'Забронирован',
  [holdStatesTypes.released]: 'Освобожден',
  [holdStatesTypes.weight_committed]: 'Принят весовой',
  [holdStatesTypes.weight_holding]: 'Забронирован весовой'
};
/**
 * Order placements
 *
 * @type {object}
 */

export const placementsTypes = {
  supplier: 'supplier',
  warehouse: 'warehouse',
  pickupPoint: 'pickupPoint',
  ops: 'ops'
};
export const placements = {
  [placementsTypes.supplier]: 'У поставщика',
  [placementsTypes.warehouse]: 'На складе',
  [placementsTypes.pickupPoint]: 'В пункте самовывоза',
  [placementsTypes.ops]: 'У транспортной компании'
};